import React from 'react';
import HeaderNews from './HeaderNews';
import TopHead from './img/Swachhta2018.jpg';
class Assets extends React.Component {
	render() {
		return(

			<div>
				<HeaderNews />
		        <div className="pages section">
					<div className="container">
						<div className="blog-single">
							<div className="blog-single-content">
								{/* <h6>Click on the links below to download the Banner, Backdrop, Poster and Standee,Poster and Placard for Swachhta Pakhwada</h6> */}
								
                    <div className="row">
                      <div className="col s12" style={{ borderBottom : '1px solid', borderBottomColor: '#d0cfce'}}>
                        <a href='/assetsDownload'>
                          <img src="https://www.indianoilxpress.com/xpresshome/English-Banner.jpg" alt="IndianOil Xpress"/>
                        </a>
                      </div>
                      <div className="col s12" style={{ borderBottom : '1px solid', borderBottomColor: '#d0cfce', marginTop:'15px'}}>
                        <a href='/assetsDownload'>
                            <img src="https://www.indianoilxpress.com/xpresshome/Corp_highlights2019.png"/>
                        </a>
                      </div>
                      <div className="col s12" style={{ borderBottom : '1px solid', borderBottomColor: '#d0cfce',  marginTop:'15px'}}>
                        <a href='/assetsDownload'>
                          <img src="https://www.indianoilxpress.com/xpresshome/Cyber-Security_23_05_2019.jpg" alt="IndianOil Xpress"/>
                        </a>
                      </div>
                      <div className="col s12" style={{ borderBottom : '1px solid', borderBottomColor: '#d0cfce',  marginTop:'15px'}}>
                        <a href='/assetsDownload'>
                            <img src="https://www.indianoilxpress.com/xpresshome/World_Environment_Day_2019.jpg"/>
                        </a>
                      </div>
                    </div>
								
							</div>		
						</div>
					</div>	
				</div>
				
				

				<div className="footer">
					<div className="container">
          <div className="copyright">
							<span>Copyright © IndianOilXpress</span><br/>
							<a href="https://www.facebook.com/IndianOilCorpLimited" target="_blank"><i class="fab fa-facebook-f"></i></a>
                <a href="https://twitter.com/indianOilcl" target="_blank"><i class="fab fa-twitter"></i></a>
                <a href="https://www.youtube.com/channel/UC5ho18VZHwEFSahW0Q_o-6g/feed" target="_blank"><i class="fab fa-youtube"></i></a>
				<a href="https://www.instagram.com/indianoilcorp" target="_blank"><i class="fab fa-instagram"></i></a>
				<a href="https://www.linkedin.com/company/indian-oil-corp-limited" target="_blank"><i class="fab fa-linkedin-in"></i></a>
				
						</div>
					</div>
				</div>

			</div>

		)
	}
}

export default Assets;


// WEBPACK FOOTER //
// ./src/assets.js